module.exports = __webpack_public_path__ + "assets/img/jlc.50913842.png";